import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import styles from './NotFound.module.css';
import { CommonPageStep, ResetPasswordPageStep } from '../..';
import { useAppSelector } from '../../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';
import { NotFoundElement, NotFoundElementInterface } from '../NotFoundElement';

export const MobileView = (): JSX.Element => {
  // REDUX
  const appPageStep = useAppSelector(selectAppPageStep);

  // ELEMENT
  const notFoundElement: NotFoundElementInterface = NotFoundElement();
  return (
    <React.Fragment>
      <Box className={styles.mainPage}>
        <Box className={styles.mainGroupBox}>
          <Box className={styles.mainGrounpBoxHead}>
            <Box className={styles.mainGrounpBoxHeadLine}>
              <span className={styles.ooopsText}>Ooops!</span>
            </Box>
            <Box className={styles.mainGrounpBoxHeadLine}>
              <span className={styles.descriptionText}>404 Page Not Found</span>
            </Box>
          </Box>
          <Box style={{}}>
            <Box className={styles.mainGroupBoxDescription}>
              <span
                className={styles.mainGroupBoxDescriptionText}
              >{`Oh no, I can’t seem to find the page you’re looking for. Let me lead your way back to Big Bang Academy!`}</span>
            </Box>
          </Box>
          <Box className={styles.sadCodyIconBox}>
            {notFoundElement.sadCodyIcon}
          </Box>
          {notFoundElement.backHomeButton}
        </Box>
      </Box>
      <header className={styles.headerGroup} id="common-navi-bar">
        <img
          className={styles.bbaLogoIcon}
          id="entry-header"
          alt=""
          src="assets/common/bba-logo.svg"
        />
      </header>
    </React.Fragment>
  );
};
